import { TranslationKeys } from '../../Constants/TranslationKeys'
import { renderTranslation, stopPropagation } from '../../Helpers/GenericHelpers'

import DiscountInput from './DiscountInput'
import {
  resetSelectedBrands,
  setBrandSearch,
  clearDiscounts,
  cleaningPopup,
} from '../../Slices/Omnichannel/DiscountSlice'
import { Input, Popconfirm, Popover } from 'antd'
import { SearchOutlined, LockFilled, CloseOutlined } from '@ant-design/icons'
import { listingsAllValue } from '../../Constants/Configuration'
import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { ClearOutlined } from '@ant-design/icons'

/**

 * @param {any} currentRule;
 * @param {any} editDisabled;
 * @param {function} createSubrule;
 * @param {any} currentListing;
 */

export default function DiscountTableHeader(props) {
  const dispatch = useAppDispatch()
  const language = useAppSelector(state => state.present.language.value)
  const brandSearch = useAppSelector(state => state.present.discount.brandSearch)
  const brandsSelected = useAppSelector(state => state.present.discount.brandsSelected)

  const resetBrandSelected = useCallback(
    e => {
      e.stopPropagation()
      dispatch(resetSelectedBrands())
    },
    [dispatch],
  )
  const clearAllDiscounts = useCallback(
    e => {
      e.stopPropagation()
      dispatch(clearDiscounts())
      dispatch(cleaningPopup(false))
    },
    [dispatch],
  )
  const openPopup = useCallback(
    e => {
      e.stopPropagation()
      dispatch(cleaningPopup(true))
    },
    [dispatch],
  )
  const closePopup = useCallback(
    e => {
      e.stopPropagation()
      dispatch(cleaningPopup(false))
    },
    [dispatch],
  )
  return (
    <div>
      <div className='main-table-title-box text-center'>
        <span
          className={props.editDisabled ? '' : 'text-underline cursor-pointer'}
          onClick={e => {
            e.stopPropagation()
            props.createSubrule(undefined, undefined, undefined)
          }}
        >
          {renderTranslation(language, TranslationKeys.discountGeneralDiscount)} <br />
          {props.currentRule
            ? props.currentRule.season.name
              ? props.currentRule.season.name
              : props.currentRule.season.outlet
              ? renderTranslation(language, TranslationKeys.seasonBoxOutlet)
              : props.currentRule.season.carryOver
              ? renderTranslation(language, TranslationKeys.seasonBoxCarryOver)
              : ''
            : ''}
        </span>
        <div className='main-table-discount'>
          <DiscountInput
            editDisabled={props.editDisabled || !props.currentListing?.find(y => y.value === listingsAllValue)}
          />
          {!props.editDisabled ? (
            <div id='clear-btn'>
              <Popover content={renderTranslation(language, TranslationKeys.discountIconClear)} trigger='hover'>
                <Popconfirm
                  title={renderTranslation(language, TranslationKeys.discountClearMessage)}
                  onConfirm={clearAllDiscounts}
                  onCancel={closePopup}
                  okText={renderTranslation(language, TranslationKeys.configurationDropdownPopYes)}
                  cancelText={renderTranslation(language, TranslationKeys.configurationDropdownPopNo)}
                >
                  <ClearOutlined onClick={openPopup} className='generic-icon' />
                </Popconfirm>
              </Popover>
            </div>
          ) : null}
        </div>
      </div>
      <div className='main-table-list'>{renderTranslation(language, TranslationKeys.discountListHead)}</div>
      <div className={'main-table-search' + (brandsSelected.length > 0 ? '' : ' lockless-space')}>
        <Input
          variant={'borderless'}
          placeholder={renderTranslation(language, TranslationKeys.filterBrand)}
          prefix={
            <div>
              {brandsSelected.length > 0 ? (
                <>
                  <div className='break-lock-line' onClick={resetBrandSelected}></div>
                  <LockFilled className='general-icon input-lock-brand-icon' onClick={resetBrandSelected} />
                </>
              ) : null}
              <SearchOutlined className='general-icon input-search-icon-alt' />
            </div>
          }
          className='availabilities-search'
          value={brandSearch}
          onChange={e => {
            dispatch(setBrandSearch(e.target.value))
          }}
          onClick={stopPropagation}
          allowClear={{ clearIcon: <CloseOutlined className='general-icon input-clear-icon' /> }}
        />
      </div>
    </div>
  )
}
